// import { createStore, applyMiddleware, compose } from "redux";
// import createSagaMiddleware from "redux-saga";

import rootReducer from "./reducers";
import { configureStore } from "@reduxjs/toolkit";
// import { useDispatch } from "react-redux";

const store = configureStore({ reducer: rootReducer });

export default store;
// export type AppDispatch = typeof store.dispatch
// export const useAppDispatch: () => AppDispatch = useDispatch // Export a hook that can be reused to resolve types
